/**
 * トップ初回訪問時のみオープニングを再生し、終了後に homeMv 用ゲートを解除する。
 */
const STORAGE_KEY = 'art_kougyou_opening_done';
const OPENING_MS = 3900;

function releaseHomeGate() {
  document.documentElement.classList.remove('js-home-initial-gate');
  document.dispatchEvent(new CustomEvent('home:gate-released', { bubbles: true }));
}

function removeOpening(el) {
  el?.remove();
}

function finishOpening(opening) {
  document.documentElement.classList.remove('is-opening');
  releaseHomeGate();
  removeOpening(opening);
}

function skipOpening(opening) {
  removeOpening(opening);
  releaseHomeGate();
}

/** 色パスごとに左右ランダムな終了角度を CSS 変数で渡す */
function setColorPathRotations(opening) {
  opening.querySelectorAll('.opening-logo__path--color').forEach((path) => {
    const sign = Math.random() < 0.5 ? -1 : 1;
    const deg = sign * (12 + Math.floor(Math.random() * 16));
    path.style.setProperty('--opening-rotate-end', `${deg}deg`);
  });
}

function playOpening(opening) {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // private モード等
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    finishOpening(opening);
    return;
  }

  setColorPathRotations(opening);
  document.documentElement.classList.add('is-opening');
  window.setTimeout(() => finishOpening(opening), OPENING_MS);
}

function initOpening() {
  const opening = document.querySelector('.opening');
  if (!opening) {
    return;
  }

  let seen = false;
  try {
    seen = localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    seen = false;
  }

  if (seen) {
    skipOpening(opening);
    return;
  }

  playOpening(opening);
}

initOpening();
document.addEventListener('swup:replaced', initOpening);
